import api from '../../../lib/api';
import type {
  MfaSetupResponse,
  MfaStatus,
  PasswordPolicy,
  SecurityAuditAction,
  SecurityAuditListResponse,
} from './types';

export interface ListAuditLogsParams {
  action?: SecurityAuditAction;
  userId?: number;
  from?: string;
  to?: string;
  page?: number;
  pageSize?: number;
}

export const fetchSecurityAuditLogs = async (
  params: ListAuditLogsParams = {},
): Promise<SecurityAuditListResponse> => {
  const { data } = await api.get<SecurityAuditListResponse>('security/audit-logs', { params });
  return data;
};

export const fetchPasswordPolicy = async (): Promise<PasswordPolicy> => {
  const { data } = await api.get<PasswordPolicy>('security/password-policy');
  return data;
};

export const updatePasswordPolicy = async (payload: Partial<PasswordPolicy>): Promise<PasswordPolicy> => {
  const { data } = await api.put<PasswordPolicy>('security/password-policy', payload);
  return data;
};

export const requestPasswordReset = async (email: string): Promise<{ message: string }> => {
  const { data } = await api.post<{ success: boolean; message: string }>(
    'platform/auth/forgot-password',
    { email },
  );
  return { message: data.message };
};

export const resetPassword = async (
  token: string,
  newPassword: string,
): Promise<{ success: boolean; message: string }> => {
  const { data } = await api.post<{ success: boolean; message: string }>(
    'platform/auth/reset-password',
    { token, newPassword },
  );
  return data;
};

export const fetchMfaStatus = async (): Promise<MfaStatus> => {
  const { data } = await api.get<MfaStatus>('security/mfa/status');
  return data;
};

export const setupMfaEnrollment = async (): Promise<MfaSetupResponse> => {
  const { data } = await api.post<MfaSetupResponse>('security/mfa/setup');
  return data;
};

export const confirmMfaEnrollment = async (code: string): Promise<{ success: boolean }> => {
  const { data } = await api.post<{ success: boolean }>('security/mfa/confirm', { code });
  return data;
};

export const disableMfa = async (): Promise<{ success: boolean }> => {
  const { data } = await api.delete<{ success: boolean }>('security/mfa');
  return data;
};
